export const SaveStateFilters = { unsaved: 0, saved: 1, everything: 2 };
export const QualityFilter = { suggested: 0, accepted: 1, everything: 2 };
export const RelationsFilter = {
  no_relations: 0,
  has_relations: 1,
  everything: 2,
};

export const FlagFilter = {
  no_flags: 0,
  issue: 1,
  quality: 2,
  uncertain: 3,
  everything: 4,
};
